import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import routes from '../routes/route';
import tableAppContentCatalog from './tableAppContentCatalog';
import viewAppCategories from './viewRelatedAppCategoriesWhiteLabel';

export default {
  attributeName: 'appContent',
  isDragable: false,
  canOpen: true,
  canChangePosition: true,
  sortingPositionIndex: 'sortingIndex',
  isMultiSelectable:true,
  canEdit: true,
  canCreate: false,
  canRemove: true,
  bulkDelete: true,
  createPath: routes.APP_CONTENT_NEW,
  editURL: routes.APP_CONTENT_EDIT,
  fromCatalogTable: tableAppContentCatalog,
  fromCatalogTableMultiple: true,
  emptyMessage: "You don't have videos, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'visibility',
      label: 'Visibility',
      type: FormInputTypes.SELECT,
      helpText: 'Visibility of the video in the panel where its listed.',
      options: [
        { name: 'Enabled', value: 'enabled' },
        { name: 'Disabled', value: 'disabled' },
        { name: 'Hidden', value: 'hidden' },
      ],
      canEdit: true,
      canCreate: false,
      // width: '10rem',
      exactWidth:'80px'
    },
    {
      attributeName: 'isLive',
      label: 'Type',
      type: FormInputTypes.TAG,
      colorWhen:[{value:true,color:"#ffffff"},{value:false,color:"#ffffff"}],
      bkWhen:[{value:true,color:"#f12027"},{value:false,color:"#0133FB"}],
      textWhen:[{value:true,text:"LIVE"},{value:false,text:"VOD"}],
      maxTagWidth:'40px',
      helpText: 'type of content (Live or VOD).',
      // width:'1rem',
      exactWidth:'30px',
      small:true

    },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Title of the video.',
      default: '',
      canEdit: true,
      canCreate: false,
      canFilter: true,
    },
    {
      attributeName: 'appCategories',
      label: 'Categories',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      canFilter: true,
      configFile: viewAppCategories,
      default: [],
      helpText: 'Video categories joined.',
      exactWidth: '250px',
    },
    {
      attributeName: 'sortingIndex',
      label: 'Index',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canEdit: false,
      canCreate: false,
      canFilter: false,
      default: [],
      // width: '3rem',
      exactWidth:'50px',
      small:true

    },
  ],
};
